import { GetAddressDTO } from '../../../../types/address.types';
import { BaseDTO } from '../../../../utils/base.dto';
import { Collection } from '../../../collections/collections.types';
import { CommercialPolicyDTO } from '../../../commercial-policies/commercialPolicies.types';
import { PaymentMethod } from '../../../payment-method/payment-method.types';
import { DeliveryWindow } from '../../../products/ProductTypes';
import { OrderType } from '../../interfaces/orderType.enum';
import { OrderCondition } from '../interfaces/orderCondition.interface';
import { OrderConditionBusinessPolicyVoucher } from '../orderCondition.types';
import { OrderConditionSelectedCustomField } from '../types/orderConditionCustomFields.types';
import { GetOrderConditionBusinessPolicyDTO } from './get-order-condition-business-policy.dto';

export class GetOrderConditionDTO extends BaseDTO<GetOrderConditionDTO> {
  id: string = '';

  orderType: OrderType = OrderType.BOTH;

  deliveryAddress?: GetAddressDTO;

  payment?: PaymentMethod;

  deliveryWindow?: DeliveryWindow;

  orderClassifications?: { code: string; typeCode: string }[];

  observation?: string;

  internalObservation?: string;

  collection?: Collection;

  commercialPolicy?: CommercialPolicyDTO;

  commercialDiscount?: number;

  orderConditionBusinessPolicies?: GetOrderConditionBusinessPolicyDTO[];

  customFields: OrderConditionSelectedCustomField[] = [];
  billingForecastDate?: Date | null;

  static toState(dto: GetOrderConditionDTO): OrderCondition {
    const vouchers: OrderConditionBusinessPolicyVoucher[] =
      dto.orderConditionBusinessPolicies?.map(({ businessPolicy, appliedAt, ...voucher }) => ({
        ...voucher,
        id: businessPolicy.id,
        name: businessPolicy.name,
        active: businessPolicy.active,
        applicationDate: appliedAt,
      })) || [];

    return {
      ...dto,
      id: dto.id,
      businessPolicies: vouchers,
      commercialPolicy: dto.commercialPolicy,
      billingForecastDate: dto.billingForecastDate ?? undefined,
    };
  }
}
